module.exports = __webpack_public_path__ + "static/sign-3409357def052a0178aeecc9871ee08d.png";